<script setup lang="ts">
import { Check } from 'lucide-vue-next';

const props = defineProps<{
    feature: string;
}>();
</script>

<template>
    <li class="flex gap-2 items-start m-0 p-0">
        <Check class="h-4 w-4 text-green-600" />{{ props.feature }}
    </li>
</template>
